import React from 'react';
import _ from 'lodash';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Autoplay, Pagination, Navigation } from 'swiper';

import Banner from '../Banner/Banner';
import './BannerCarousel.scss';

SwiperCore.use([Pagination, Autoplay, Navigation]);

export default function BannerCarousel({ data, configuration }: Record<string, any>) {
  const swiperRef = React.useRef<SwiperCore>();
  const onInit = (Swiper: SwiperCore): void => {
    swiperRef.current = Swiper;
  };

  return (
    <Swiper
      onInit={ onInit }
      className="banner-carousel"
      { ...configuration }
    >
      {
        _.map(data, (tab, i) => (
          <SwiperSlide key={ `${ tab.title }${ i }` }><Banner data={ tab } /> </SwiperSlide>
        ))
      }
    </Swiper>
  );
}
